import { useLanguage } from '../contexts/LanguageContext';

function ProteccionDatos() {
  const { t } = useLanguage();
  return (
    <section className="section section--legal">
      <div className="section-inner section-inner--narrow">
        <br />
        <br />
        <br />
        <h1 className="section-title">{t('proteccion.title')}</h1>
        <p className="section-intro">{t('proteccion.intro')}</p>

        <div className="legal-block">
          <h2>{t('proteccion.s1Title')}</h2>
          <p>{t('proteccion.s1Content')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s2Title')}</h2>
          <p>{t('proteccion.s2P1')}</p>
          <ul>
            <li>{t('proteccion.s2L1')}</li>
            <li>{t('proteccion.s2L2')}</li>
          </ul>
          <p>{t('proteccion.s2P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s3Title')}</h2>
          <p>{t('proteccion.s3P1')}</p>
          <ul>
            <li>{t('proteccion.s3L1')}</li>
            <li>{t('proteccion.s3L2')}</li>
            <li>{t('proteccion.s3L3')}</li>
          </ul>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s4Title')}</h2>
          <p>{t('proteccion.s4P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s5Title')}</h2>
          <p>{t('proteccion.s5P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s6Title')}</h2>
          <p>{t('proteccion.s6P1')}</p>
          <p>{t('proteccion.s6P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s7Title')}</h2>
          <p>{t('proteccion.s7P1')}</p>
          <p>{t('proteccion.s7P2')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s8Title')}</h2>
          <p>{t('proteccion.s8P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s9Title')}</h2>
          <p>{t('proteccion.s9P1')}</p>
        </div>

        <div className="legal-block">
          <h2>{t('proteccion.s10Title')}</h2>
          <p>{t('proteccion.s10P1')}</p>
          <p className="legal-disclaimer">{t('proteccion.disclaimer')}</p>
        </div>
      </div>
    </section>
  );
}

export default ProteccionDatos;
